import { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

const useQueryAsState = () => {
  const { pathname, search } = useLocation()
  const navigate = useNavigate()

  // helper method to convert {key1:value,k:v} to '?key1=value&k=v'
  const objectToQueryParams = (params) => {
    return new URLSearchParams(params).toString()
  }

  // helper method to create an object from URLSearchParams
  const getQueryParamsAsObject = (urlSearchParams) => {
    const res = Object.fromEntries(urlSearchParams)
    return res
  }

  const params = useMemo(() => {
    return getQueryParamsAsObject(new URLSearchParams(search))
  }, [pathname, search])

  const updateQuery = (updatedParams) => {
    Object.assign(params, updatedParams)
    const route = `${pathname}?${objectToQueryParams(params)}`
    navigate(route, { replace: true })
  }

  return [params, updateQuery]
}

export default useQueryAsState
